import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderAgencycsw = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl='https://customsprem.gov.tc/';
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [tblagency, setTblagency] = useState([]);
const [arragency, setArragency] = useState([]);
const [combolocation, setCombolocation] = useState([]);

const [arraycaseworker, setArraycaseworker] = useState([]);
const [caseworkeroptions, setCaseworkeroptions] = useState([]);

const [agency, setAgency] = useState({});
const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	txt:''
	, usergroup:''
	, custype:''
	, userlocation: ''
	});




const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Agency Case-workers";	

if (tblagency.length<1){
	tblagencycsw();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	
	if (tblagency.length>0 && arraycaseworker.length==0)
		getcaseworkerareas();
	//document.getElementsByName('txt')[0].focus();
 },[JSON.stringify(tblagency)]);

useEffect(() => {
	
	if (arragency.length>0)
		writeTblagency();
	//document.getElementsByName('txt')[0].focus();
 },[JSON.stringify(arragency)]);


useEffect(() => {
console.log("modal.open: "+modal.open);

if (modal.open==false)
		setAgency({});

if (arraycaseworker.length>0 && modal.open==true){
	let temp=[];
	
	for (var i=0; i<arraycaseworker.length; i++){
		const cw=arraycaseworker[i];
		const key="cwopt_"+i;

		//console.log("agency.TC_ISLAND.toUpperCase(): "+agency.TC_ISLAND.toUpperCase());
		//console.log("cw.PROCESS_AREA.toUpperCase(): "+cw.PROCESS_AREA.toUpperCase());
		if (cw.PROCESS_AREA.toUpperCase()=="GENERAL")
			if (cw.TC_ISLAND.toUpperCase()==agency.TC_ISLAND.toUpperCase() || agency.TC_ISLAND=="")
				temp.push(<option key={key} value={cw.USERNAME} >{cw.FULLNAME}</option>);
		
		}//end for
	setCaseworkeroptions(temp);
	
	}//end if

 },[arraycaseworker.length, modal.open]);


useEffect(() => {

if (!agency.AGENCY_ID)
	return;

	console.log('agency.AGENCY_ID: '+agency.AGENCY_ID);
	if (agency.AGENCY_ID!=undefined){
		if (modal.open==false)
			toggleModalsm();
			
		}//end if
	
 },[agency.AGENCY_ID]);

useEffect(() => {

	if (!agency.CASE_WORKER)
		return;

	const btnsave=document.getElementById("btnsave");

	if (agency.CASE_WORKER==""){
		if (!btnsave.classList.contains("hidden"))
			btnsave.classList.add("hidden");
		}
	else {
		if (btnsave.classList.contains("hidden"))
			btnsave.classList.remove("hidden");
		}//end else

 },[agency.CASE_WORKER]);


useEffect(() => {
		//console.log("JSON.stringify(arragency): "+JSON.stringify(arragency));
 },[JSON.stringify(arragency)]);
 
useEffect(() => {
		tblagencycsw();
 },[searchcrit]);

function searchcritChange(e){
	
	const {name, value}=e.target;
console.log("searchcritChange name: "+name+' '+value);

	setSearchcrit((prev)=>{
		return {...prev, [name]:value}	
	});
	
	//setSearchcrit({name:e.target.name, txt:e.target.value});
}//end if

async function tblagencycsw(){

let params = searchcrit;
params.USERNAME=sessionStorage.getItem("USERNAME")

console.log("tblagencycsw: "+JSON.stringify(params));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setTblagency([]);
  await fetch(resturl+'rarwpform/tblagencycsw',requestOptions)
      .then(res => res.json())
      .then(res => 	aftertblagencycsw(res) )
      .catch(err => console.log(err));

}//end func


async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

  await fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwpformoptions(res){

let templocation=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='location' && !strOption.toUpperCase().includes("UNKNOWN"))
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	
	});//end map
setCombolocation(templocation);

}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

if (!document.getElementById("btnsave").classList.contains("hidden"))
	document.getElementById("btnsave").classList.add("hidden");
		
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func


async function submitform1(e){
e.preventDefault();
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), agency:agency} )
  };		
		
  await fetch(resturl+'rarwpform/updateagencycsw',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdateagencycsw(res) )
      .catch(err => console.log(err));

}//end func

function afterupdateagencycsw(res){
	let UPDATE_COUNT=0;
	
	if (res.length)
		if (res.length>0)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	if (UPDATE_COUNT>0){



		setAgency((prev)=>{
			return {...prev
			, CASE_WORKER:res[0].CASE_WORKER
			, CSWKR_UPDATE_BY:res[0].CSWKR_UPDATE_BY
			, CSWKR_UPDATE_DATE:res[0].CSWKR_UPDATE_DATE
			}
			});

		console.log("agency.AGENCY_ID: "+agency.AGENCY_ID);
		for (var i=0; i<arragency.length; i++){
			if (arragency[i].AGENCY_ID==agency.AGENCY_ID){
				//console.log("afterupdateagencycsw arragency[i].CASE_WORKER: "+arragency[i].CASE_WORKER);
				console.log("res[0].CASE_WORKER: "+res[0].CASE_WORKER);
				let temparragency=arragency;
				temparragency[i].CASE_WORKER=res[0].CASE_WORKER;
				temparragency[i].CSWKR_UPDATE_BY=res[0].CSWKR_UPDATE_BY;
				temparragency[i].CSWKR_UPDATE_DATE=res[0].CSWKR_UPDATE_DATE;
				setArragency((prev)=>{
					prev=temparragency;
					return [...prev]
					});
				const CASE_WORKER_CELL_ID=temparragency[i].CASE_WORKER_CELL_ID;
				document.getElementById(CASE_WORKER_CELL_ID).innerHTML=res[0].CASE_WORKER_NAME;
				}//end if
			}//end for
		
		//document.getElementById(agency.CASE_WORKER_CELL_ID).innerHTML=res[0].CASE_WORKER_NAME;
		showsnackbar("update complete");
		}
	else
		showsnackbar("update failed.  please try again or contact admin");
}//end func
	
	
	
	
async function addnewagency(e){

e.preventDefault();

const agency=window.prompt("enter name of new agency: ");
if (!agency){
	return;
	}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), AGENCY:agency.trim()} )
  };		

	
  await fetch(resturl+'rarwpform/addnewagency',requestOptions)
      .then(res => res.json())
      .then(res => 	afteraddnewagency(e, res) )
      .catch(err => console.log(err));

}//end func

function afteraddnewagency(e, res){
	let AGENCY="";
	if (res.length)
		AGENCY=res[0].AGENCY??"";
	
	if (AGENCY=="")
		showsnackbar("That did not work!");
	else
		showsnackbar("AGENCY is added: "+AGENCY);
	
}//end func

	
async function getcaseworkerareas(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		
	setCaseworkeroptions([]);
	
  await fetch(resturl+'rarwpform/getcaseworkerareas',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcaseworkerareas(res) )
      .catch(err => console.log(err));

}//end func

function aftergetcaseworkerareas(res){
	if (!res.length)
		return;
let temp=[];
res.map((col, index) => {
	const combo=col['COMBO'];
//	const key=combo+"_"+index;
	temp.push({
		USERNAME:col['USERNAME']
		, FULLNAME:col['FULLNAME']
		, TC_ISLAND:col['TC_ISLAND']
		, PROCESS_AREA:col['PROCESS_AREA']
		});
	});//end map
	
setArraycaseworker(temp);

}//end func


function writeTblagency(){
	
	
let htmrows=[];

arragency.map((col, index) => {
	const trkey='tr_'+index;
	const rdkey='td_'+index;
	const CASE_WORKER_CELL_ID=col['CASE_WORKER_CELL_ID'];
	//CASE_WORKER_CELL_ID
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{1+index}</td>
	<td align='left' >{col['TC_ISLAND']}</td>
	<td align='left' id={CASE_WORKER_CELL_ID} >{col['CASE_WORKER_NAME']}</td>
	<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{openAgency(e, index);}}><img src="img/folderyelsmall.png"  height='18'  border="0" /> {col['AGENCY']}</a></td>
	<td align='center' >{col['APP_DATE']}</td>
	<td align='left' >{col['COMPANY']}</td>
	<td align='left' >{col['OCCUPATION']}</td>
	<td align='left' >{col['MPE_NAME']}</td>
	</tr>;
	htmrows.push(htmrow);
	

});	

setTblagency(htmrows);	
}//end func

function openAgency(e, i){
	e.preventDefault();
	//console.log("openAgency: "+JSON.stringify(arragency[i]));
	setAgency(arragency[i]);
}//end func

function aftertblagencycsw(res){
	
if (combolocation.length==0)
	getwpformoptions();
	
if (res.length==undefined)
	return;
	
console.log('aftertblagencycsw, res.length: '+res.length);
/*
	<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{getwptuser(e, USERNAME);}}><img src="img/folderyel.png"  height='18'  border="0" /> {col['FULLNAME']}</a></td>
folderyelsmall.png
{col['AGENCY']}
*/

let temparragency=[];

res.map((col, index) => {
	
		//, CASE_WORKER_CELL_ID:""
	temparragency.push({
		INDEX:index
		, AGENCY_ID:col['AGENCY_ID']
		, AGENCY:col['AGENCY']??""
		, CASE_WORKER:col['CASE_WORKER']??""
		, CASE_WORKER_NAME:col['CASE_WORKER_NAME']??""
		, CSWKR_UPDATE_BY:col['CSWKR_UPDATE_BY']??""
		, CSWKR_UPDATE_DATE:col['CSWKR_UPDATE_DATE']??""
		, TC_ISLAND:col['TC_ISLAND']??""
		, APP_DATE:col['APP_DATE']??""
		, OCCUPATION:col['OCCUPATION']??""
		, COMPANY:col['COMPANY']??""
		, MPE_NAME:col['MPE_NAME']??""
		, CASE_WORKER_CELL_ID: "agency_"+index

		});
	});
	
setArragency(temparragency);

}//end func



function handleChange(e){
const {name, value}	=e.target;

setAgency((prev)=>{
	return {...prev, [name]:value}
	});
	

}//end func

	
	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Agencies and assigned Case Workers
	</p>
	<div align="center" ><a href="#" onClick={(e)=>{e.preventDefault();navigate("/lbr_clr_app");}} className="nodecor" ><img src="img/return.png" border="0" /> return to labour clearance</a></div>
	<table align='center' className='customers' style={{width:"90%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th>Island</th>
		<th>Case Worker</th>
		<th>
		{
			sessionStorage.getItem("USERNAME")=="ajones" && 
			<>
			<a href="#"  onClick={(e)=>{addnewagency(e);}} ><img src="img/addbutton.png" border="0" /></a>
			&nbsp;&nbsp;
			</>
		}
		Agency
		</th>
		<th>Recent<br/>Labour Clear.</th>
		<th>Employer Name</th>
		<th>Occupation</th>
		<th>Worker Name</th>
	</tr>
	</thead>
	<tbody>
		{tblagency}
	</tbody>
	</table>



<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >Agency: </td>
			<td align='left' ><input value={agency.AGENCY} readOnly className="gnsbro" /></td>
			</tr>	
			<tr>
			<td align='right' >Case Worker: </td>
			<td align='left' >
				<select name="CASE_WORKER" onChange={(e)=>{handleChange(e);}} value={agency.CASE_WORKER} required >
				<option value="" ></option>
				{caseworkeroptions}
				</select>
			</td>
			</tr>	

			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' ><button id="btnsave" className="button hidden"  >save changes</button></td>
			</tr>	
			
			<tr>
			<td align='right' >Case-worker Updated by: </td>
			<td align='left' >{agency.CSWKR_UPDATE_BY}</td>
			</tr>	
			<tr>
			<td align='right' >Case-worker Updated Date: </td>
			<td align='left' >{agency.CSWKR_UPDATE_DATE}</td>
			</tr>	
			
			</tbody>
			</table>
			</form>
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderAgencycsw;